import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "xiangbei-phone",
  "use": "xiangbei-phone-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"xiangbei-phone\"><path d=\"M11.792 1h-7.25a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7.25a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1ZM8.167 12.906a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol